

export const setIsAuthenticated = ({ commit }, data) => {
  commit('setIsAuthenticated', data)
}

export const setUser = ({ commit }, data) => {
  commit('setUser', data)
  if (data) {
    localStorage.setItem('userInfo', JSON.stringify(data))
  } else {
    localStorage.removeItem('userInfo')
  }
}

export const setCurrentState = ({ commit }) => {
  commit('setUser', {})
  commit('setIsAuthenticated', false)
  localStorage.removeItem('token')
  localStorage.removeItem('userInfo')
}

export const setLoading = ({ commit }, data) => {
  commit('setLoading', data)
}

export const checkLoginStatus = async ({ commit }, { uhidden, fmtoken }) => {
  try {
   
    console.log(fmtoken)

          commit('setUser', user)
      commit('setIsAuthenticated', true)

      localStorage.setItem('token', fmtoken)
      localStorage.setItem('userInfo', JSON.stringify(user))
  } catch (err) {
    console.error('登录状态检查失败：', err)
    commit('setUser', {})
    commit('setIsAuthenticated', false)
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js